import React from 'react'
import './Footer.css'
function Footer() {
  return (
    <div className='Footer'>
        <h3 className='statement'>̥copyright 2022|All Rights Reserved| Built by Team VCoders </h3>

    </div>
  )
}

export default Footer